import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faShoppingCart,
  faBox,
  faChartBar,
  faFileAlt, // new icon for Reports
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <footer className="bg-gray-900 border-t border-gray-800 fixed bottom-0 left-0 w-full z-50">
      <div className="flex justify-between px-2 sm:px-4 py-1 sm:py-2">
        <Link
          to="/home"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/home") ? "text-blue-400 bg-gray-800" : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faHome} className="text-xl mb-0.5" />
          Home
        </Link>

        <Link
          to="/customer"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/customer")
              ? "text-blue-400 bg-gray-800"
              : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faUser} className="text-xl mb-0.5" />
          Delivery
        </Link>

        <Link
          to="/deliveries"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/deliveries")
              ? "text-blue-400 bg-gray-800"
              : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faShoppingCart} className="text-xl mb-0.5" />
          Orders
        </Link>

        <Link
          to="/all-customers-invoice"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/all-customers-invoice")
              ? "text-blue-400 bg-gray-800"
              : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faChartBar} className="text-xl mb-0.5" />
          Ledger
        </Link>

        {/* <Link
          to="/product"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/product") ? "text-blue-400 bg-gray-800" : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faBox} className="text-xl mb-0.5" />
          Products
        </Link> */}

        <Link
          to="/reports"
          className={`flex flex-col items-center text-xs px-2 py-1 rounded ${
            isActive("/reports") ? "text-blue-400 bg-gray-800" : "text-gray-400"
          }`}
        >
          <FontAwesomeIcon icon={faFileAlt} className="text-xl mb-0.5" />
          Reports
        </Link>

      </div>
    </footer>
  );
};

export default Footer;
